import { translate } from "@atoms/atom-client/i18n";
/**
 * The kinds of instrument the instrument database knows.
 *
 * Keys must equal their values: the atom codegen reads the enum by value.
 * Keep at least two members: TypeScript reads a one-member enum as a plain
 * literal type, and the codegen then stores the field as untyped JSON.
 */
export enum InstrumentCategory {
  Keyboard = "Keyboard",
  Other = "Other",
}

/** Category labels in the UI language (read on access). */
export const INSTRUMENT_CATEGORY_LABELS: Record<InstrumentCategory, string> = {
  get [InstrumentCategory.Keyboard]() {
    return translate("app.shared.instrumentCategories.keyboard", "Keyboard");
  },
  get [InstrumentCategory.Other]() {
    return translate("app.shared.instrumentCategories.other", "Sonstiges");
  },
};

export const INSTRUMENT_CATEGORY_VALUES: InstrumentCategory[] =
  Object.values(InstrumentCategory);

export function isInstrumentCategory(
  value: unknown,
): value is InstrumentCategory {
  return (
    typeof value === "string" &&
    (INSTRUMENT_CATEGORY_VALUES as string[]).includes(value)
  );
}

/**
 * Whether the key count (Tasten-Anzahl) means anything for the category.
 */
export function categoryHasKeyCount(category: InstrumentCategory): boolean {
  return category === InstrumentCategory.Keyboard;
}

/**
 * The case type a new instrument of the category starts on.
 *
 * A plain string: `@project/shared` cannot see the `LTProducts` enum of
 * `@project/manufacturer`, which depends on this package. The value must be
 * one of its members; the backend refuses anything else.
 */
export function defaultProductTypeForCategory(
  category: InstrumentCategory,
): string {
  switch (category) {
    case InstrumentCategory.Keyboard:
      return "keyboardcase";
    case InstrumentCategory.Other:
      return "koffer";
  }
}
